
<div class="form-body" [class.no-side]="!loading && !hasSideContent">
  <div class="form-main">
    @if (loading) {
      <div class="toppadding">
        <div class="loader"></div>
      </div>
    }
    @if (!loading) {
      <div class="article-header">
        <div>
          <h1 class="main-title">{{article.nestingNumber}} {{article.name}} <span class="noteStyle">{{article.currentVersion}}</span></h1>
          <div class="text noteStyle">{{article.articleNumber ? article.articleNumber +',':''}} {{'manuals.article-updated'|translate}}: {{article.updatedAt? (article.updatedAt|date:'dd/MM/yyyy HH:mm') : '-'}}</div>
        </div>
        @if (article.hasPreviousVersion) {
          <div class="switch-row inline">
            <div class="switch">
              <input type="checkbox" id="showchanged" (change)="toggleDiff()" [checked]="showDiff" autocomplete="off">
              <label for="showchanged">
                <div>
                  <div class="note">{{'manuals.mark-changes'|translate}}</div>
                </div>
              </label>
            </div>
          </div>
        }
        @if (article.summaryBlocks.length) {
          <div class="article-tabs">
            <a class="article-tab" [class.active]="summaryMode" (click)="changeSummaryMode(true)">{{'manuals.article-summary-tab'|translate}}</a>
            <a class="article-tab" [class.active]="!summaryMode" (click)="changeSummaryMode(false)">{{'manuals.article-full-tab'|translate}}</a>
          </div>
        }
      </div>
      <div class="article-body">
        <div class="form-section bordered">
          @if (!showDiff) {
            @if (summaryMode) {
              @for (block of article.summaryBlocks; track block) {
                <app-article-block  [block]="block"></app-article-block>
              }
            }
            @if (!summaryMode) {
              @for (block of article.contentBlocks; track block) {
                <app-article-block  [block]="block"></app-article-block>
              }
            }
          }
          @if (showDiff) {
            <div [innerHTML]="diffHtml"></div>
          }
          <ng-container #container></ng-container>
        </div>
        @if (!messageViewer && article.children.length) {
          <div class="form-section">
            <h2 class="form-subtitle">{{'manuals.article-navigation-title'|translate}}</h2>
            <div class="grid-table selectable bordered compact">
              @for (item of article.children; track item) {
                <a class="grid-row article-item-row compact" [routerLink]="['../',item.slug]" queryParamsHandling="preserve">
                  <div class="grid-cell icon-cell">
                    <i class="material-icons">{{item.isFolder ? 'folder': 'article' }}</i>
                  </div>
                  <div class="grid-cell">
                    <div class="grid-header">{{item.nestingNumber}} {{item.name}}</div>
                  </div>
                  <div class="grid-cell">
                    <div [matTooltip]="'manuals.article-updated'|translate">{{item.updatedAt? (item.updatedAt|date:'dd/MM/yyyy HH:mm') : '-'}}</div>
                  </div>
                </a>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  @if (!loading && hasSideContent) {
  <div class="form-side">
    <div class="form-side-header">

    </div>
    @if (!loading) {
      <div class="form-side-body">
        @if (showContentsTable) {
          <div class="form-side-section">
            <h4 class="form-subtitle">{{'manuals.Inhoudsopgave'|translate}}</h4>
            @if (summaryMode) {
              <ul class="table-contents">
                @for (block of article.summaryBlocks; track block; let i = $index) {
                  @if (block.name) {
                    <li (click)="scrollTo('.block-'+block.position)">
                      {{block.name}}
                    </li>
                  }
                }
              </ul>
            }
            @if (!summaryMode) {
              <ul class="table-contents">
                @for (block of article.contentBlocks; track block; let i = $index) {
                  @if (block.name) {
                    <li (click)="scrollTo('.block-'+block.position)">
                      {{block.name}}
                    </li>
                  }
                }
              </ul>
            }
          </div>
        }
        @if (article.attachments.length) {
          <div class="form-side-section">
            <div class="button-header pt0">
              <h4 class="form-subtitle">{{'Bijlagen'|translate}}</h4>
            </div>
            <div class="grid-table compact bordered selectable">
              @for (item of article.attachments; track item) {
                <div (click)="download(item.path)" class="grid-row compact file-row">
                  <div class="grid-cell avatar-cell"><app-avatar [icon]="item|mediaIcon" [image]="item.path+'?filter=thumb&width=32&height=32&mode=outbound'" size="medium"></app-avatar></div>
                  <div class="grid-cell"><div class="truncate" [matTooltip]="item.name">{{item.name}}</div></div>
                  <div class="grid-cell icon-cell">
                    <button class="icon-btn accent">download</button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (!messageViewer && article.relatedArticles.length) {
          <div class="form-side-section">
            <h4 class="form-subtitle">{{'manuals.related-articles'|translate}}</h4>
            @for (item of article.relatedArticles; track item) {
              <a [routerLink]="['../',item.slug]" class="related-article">
                <i class="material-icons">{{item.isFolder? 'folder':'article'}}</i>
                <span>{{item.name}}</span>
              </a>
            }
          </div>
        }
      </div>
    }
    <div class="form-side-footer">

    </div>
  </div>
  }
</div>

